module.exports = __webpack_public_path__ + "img/reasonableFees4x.31747079.png";